<template>
  <v-container class="p-insure px-0">
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="订单查看" class="insure-card">
          <div class="no-order">
            <p>订单号：{{policy.orderCode}}</p>
            <p>保单号：{{policy.oldPolicyNo}}</p>
            <p>保全号：{{policy.no}}</p>
          </div>
          <v-form ref="form" lazy-validation class="form">
            <!-- 投保信息 -->
            <section class="form-section">
               <v-flex class="form-item">
                <label>投保人名称</label>
                <p style="margin-top:6px">{{policy.applicantName}}</p>
              </v-flex>
              <div class="form-item">
                <label>保全类型选择</label>
                <v-radio-group :readonly="true" class="form-radio" row v-model="form.modifyFlag">
                  <v-radio label="人员新增" value="1"></v-radio>
                  <v-radio label="人员减少" value="2"></v-radio>
                  <v-radio label="人员替换" value="3"></v-radio>
                </v-radio-group>
              </div>
              <v-flex class="form-item" v-if="form.modifyFlag ==3">
                  <label>保全有效期限</label>
                  <p class="time">自{{policy.insureStartDate}}起至{{policy.insureEndDate}}止</p>
              </v-flex>

                <v-flex class="form-item">
                  <label>{{form.modifyFlag !=3?'保全有效期限':'生效日期'}}</label>
                  <!-- 只能选择明天-明天30天以内的时间 -->
                  <v-menu
                    ref="dateMenu"
                    v-model="effectBeginDateMenuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    v-if="form.modifyFlag ==3"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="date-input"
                      v-model="form.effectDate"
                      :solo="solo"
                      :rules="rules.effectDate"
                      append-icon="calendar_today"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="form.effectDate"
                      :header-date-format="date=>date"
                      :min="minEffectBeginDate"
                      :max="maxEffectBeginDate"
                      no-title
                      @input="effectBeginDateMenuVisible = false"
                    ></v-date-picker>
                  </v-menu>
                  <p class="time" v-if="form.modifyFlag !=3">自{{form.effectDate}}起至{{policy.insureEndDate}}止</p>
                </v-flex>
                <v-flex class="form-item">
                <label>投保人邮箱</label>
                <p style="margin-top:7px">{{policy.applicantEmail}}</p>
              </v-flex>
              <div>
                <label>承保方案</label>
                <InsurancePlanTable
                  v-model="form.amount"
                  :employees="employees"
                  :code="policy.productId"
                  :allRes="planAllList"
                  :plan-id="form.productPlanId"
                  :effect-duration="form.effectDuration"
                  :orderList.sync="policy"
                />
              </div>
              <v-layout class="price-footer">
                  <div class="people">本次上传人数：{{policy.insureds}}</div>
                  <div class="price">合计保费：{{policy.amounts}}</div>
              </v-layout>
            </section>
          </v-form>
          <p class="down-people" @click="downMan">保全批单查看及下载</p>
        </CSection>
        <CompanyAccountView
                :policy="policy"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import InsurancePlanTable from "@/components/Order/applyTableInfo";
import areaList from '@/assets/js/area';
import CompanyAccountView from "../../order/components/CompanyAccountView";
export default {
  components: {
    InsurancePlanTable,
    CompanyAccountView
  },
  props: {
    policy: Object,
  },
  data() {
    return {
      payUrl:'',
      totalMoney:0,
      totalCount:0,
      planAllList:{},
      downloading:false,
      areaList:areaList,
      solo: true,
      formValid: true,
      form: {
        // 生效日期
        effectDate: "",
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        modifyFlag: '1',
        amount: 0,
        email:''
      },
      rules: {
        effectDate: [v => !!v || "请选择生效日期"],
        email: [v => !!v || "请输入邮箱"]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      maxEffectBeginDate:"",
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      loading: false,
      //提交批单链接
      submitEndorsementUrl: "/app/api/heshunbao/submitEndorsement",
      downloadEmployeeUrl: "/app/api/heshunbao/downloadEmployee"
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.$store.dispatch("getUserInfo");
    this.form.effectDuration = this.policy.insurancePeriodUnit == 3?12:this.policy.insurancePeriod
    this.form.effectDate = this.policy.effectDate
    this.form.modifyFlag = this.policy.typeId+''
    this.employees = this.policy.policyDetailList
    this.planAllList = this.policy
    this.items = this.policy.insuredList
    this.minEffectBeginDate = this.$miment()
      .add(1, "DD")
      .format("YYYY-MM-DD");
    this.maxEffectBeginDate = this.policy.insureEndDate
  },
  mounted() {
    if (this.policy.productId === 2017){
      this.effectDurationList = [
        { text: "1年", value: 12 },
        { text: "11个月", value: 11 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ];
      this.downloadEmployeeUrl = "/app/api/heshunbao/b/downloadEmployee";
      this.submitEndorsementUrl =  "/app/api/heshunbao/b/submitEndorsement";
    }
  },
  methods: {
    downMan(){
      if(this.policy.electronicUrl){
        const elink = document.createElement("a");
        elink.style.display = "none";
        elink.target = "blank";
        elink.href = this.policy.electronicUrl;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    },
    onUploadSuccess(file) {
      let formData = new FormData();
      const data = {
        policyId:this.policy.id,
        effectDate:this.form.effectDate,
        modifyFlag:this.form.modifyFlag
      }
      formData.append("policyJson", JSON.stringify(data));
      formData.append("file", file);
      this.$axios.post(this.submitEndorsementUrl,formData).then(res=>{
        this.totalMoney = res.data.totalPrice;
        this.totalCount = res.data.count;
        this.payUrl = res.data.payUrl;
      })

    },
    gopay(){
      window.location.href = this.payUrl
    },
    onUploadError(err) {
      // this.$message.error(err.message);
      let error = err.message.replace(/;/g, "<br>");
      const message =
        "您导入的员工信息中有格式错误，请修改后重新上传，具体错误信息如下所示：<br>" +
        error;
      this.$messageBox.alert({
        message,
        width: 500
      });
    },
      downFile(){
        this.downloading = true
        const elink = document.createElement("a");
        elink.style.display = "none";
        elink.href = process.env.VUE_APP_API_URL+this.downloadEmployeeUrl+'?orderCode='+this.policy.orderCode;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        this.$axios.get(this.downloadEmployeeUrl+'?orderCode='+this.policy.orderCode).then(()=>{
            this.downloading = false
        }).catch(()=>{
            this.downloading = false
        })
      }
  }
};
</script>


<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
  .form-radio{
    margin-top: -2px;
    label{
      margin-top: 0;
    }
  }
  .down-people{
    color: $primary-color;
    font-size: 14px;
    border-bottom: 1px solid $primary-color;
    display: inline-block;
    cursor: pointer;
  }
  .price-footer{
  margin-top: 30px;
  justify-content: right;
}
  .time{
    font-size: 14px;
    color: $primary-color;
    margin-top: 7px;
    margin-left: 7px;
  }
.p-insure {
  .insure-card {
    .no-order{
      justify-content: space-between;
      display: flex;
      flex-flow: row;
    }
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
}
</style>
